import React, { useState, useEffect, useRef } from 'react';
import "./Kpidetails.css";
import { METRIC_INFO } from "./utils/metricInfo.js";
import { InfoTooltip } from "./utils/InfoTooltip.js";
import getCountryName from './utils/CountryMap.js';
import { useLocation } from 'react-router-dom';

export function KPIDashboard() {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [KPIData, setKPIData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [submittedRange, setSubmittedRange] = useState(null);
  const [uniqueUserNames, setUniqueUserNames] = useState([]);
  const [countryArray, setcountryArray] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [selectedCountry, setSelectedCountry] = useState('all');

  const location = useLocation();
  // Check if location.state is undefined or not
  const { responseData } = location.state || {};
  // console.log(responseData);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('footer');
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        footer.style.display = 'block';
      } else {
        footer.style.display = 'none';
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const handleDropdownToggle = () => setIsOpen(!isOpen);
  const handleSearchChange = (e) => setSearchQuery(e.target.value);
  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setSearchQuery('')
    setIsOpen(false);
  };

  const filteredCountries = countryArray.filter((name) =>
    getCountryName(name).toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    if (selectedCountry) {
      if (startDate && endDate) {
        console.log(startDate, endDate, selectedCountry);
        fetchKPIData(startDate, endDate, selectedCountry);
      }
    }
  }, [selectedCountry])

  useEffect(() => {
    if (startDate && endDate) {
      setSelectedCountry("all");
      setcountryArray([])
      fetchKPIData(startDate, endDate, "all");
    }
  }, [startDate, endDate])

  const fetchKPIData = async (start, end, country = 'all') => {
    setIsLoading(true);
    try {
      const response = await fetch(`/api/kpidetails`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ start, end, country: country, copycountryarray: countryArray }),
      });
      const result = await response.json();
      setKPIData(result);
      // setUniqueUserNames(result.uniqueUserNames || []);
      if (result.copycountryarray && result.copycountryarray.length > 0) {
        setcountryArray(result.copycountryarray);
      } else {
        setcountryArray(result.country);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitDateRange = () => {
    if (!(startDate && endDate)) {
      // console.log(`Fetching KPI details from ${startDate} to ${endDate}`); 
      // setSubmittedRange(`${startDate} - ${endDate}`);  
      // fetchKPIData(startDate, endDate);  
      alert('Please select both start and end dates.');
    }
    //  else {  
    //     alert('Please select both start and end dates.');  
    // }  
  };

  // const handleUserChange = (e) => {  
  //     const user = e.target.value;  
  //     setSelectedUser(user);  
  //     if (startDate && endDate && user) {  
  //         console.log(`Fetching KPI details for user ${user} from ${startDate} to ${endDate}`);  
  //         // setSubmittedRange(`${startDate} - ${endDate} | User: ${user}`);  
  //         fetchKPIData(startDate, endDate, user);  
  //     }  
  // };  

  const handleCountryChange = (e) => {
    const country = e.target.value;
    setSelectedCountry(country);
  };

  const getCorrected = (x) => {
    if (startDate && endDate) {
      if (x && x != "NaN" && x != undefined && x != null) {
        return typeof x === "string" ? x : Number(x.toFixed(2));
      } else {
        return 0
      }
    } else {
      return "N/A"
    }
  }

  const getdata = async () => {
    try {
      const res = await fetch("/api/access/mine", { credentials: "include" });
      const data = await res.json();
      if (!data.features.includes("getpinned")) {
        alert('You don’t have access to download the pinned user data!')
        return;
      }

      let response = await fetch('/api/getpinned', { method: "GET" });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `pinnedusers.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
    }
  }

  const handleDownloadReport = async () => {
    const confirmDownload = window.confirm(
      "Do you want to download an Excel report?"
    );

    if (!confirmDownload) return;

    if (startDate && endDate) {
      try {
        const response = await fetch(`/api/fetch_details/kmun`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ startDate, endDate }),
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const blob = await response.blob();

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `From_${startDate}_to_${endDate}.xlsx`;

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    } else {
      alert('Please select both start and end dates.');
    }
  };

  // const getdata2 = async () =>{
  //   try {
  //     let response = await fetch('/api/gettranscript',{method:"GET"});
  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = `transcript.xlsx`;
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);
  //     window.URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
  return (
    <>
      {
        isLoading ? (
          <div className="overlay">
            <div className="spinner"></div>
          </div>
        ) : <div></div>
      }
      <h1 style={{ textAlign: "center", fontSize: "2rem", color: "#333", marginBottom: "20px", marginTop: "20px" }}>Analytics Dashboard</h1>
      <div className="container_KPI">
        <div className="left-container_KPI">
          {/* Date Picker and User Dropdown */}
          <div className="datepickercontainer_KPI">
            <div className="date-picker_KPI">
              <div className="startdate_KPI">
                <label htmlFor="start-date-picker">Start date:</label>
                <input
                  type="date"
                  id="start-date-picker"
                  name="start-date-picker"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="enddate_KPI">
                <label htmlFor="end-date-picker">End date:</label>
                <input
                  type="date"
                  id="end-date-picker"
                  name="end-date-picker"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
            </div>
            <button onClick={handleSubmitDateRange}>{isLoading ? "Loading..." : "Submit"}</button>
          </div>
          {/* <div className="user-dropdown_KPI">  
          <select  
            id="unique-user-dropdown"  
            name="unique-user-dropdown"  
            value={selectedUser}  
            onChange={handleUserChange}  
          >  
            <option value="">Select a unique user</option>  
            {uniqueUserNames.length > 0 ? (  
              uniqueUserNames.map((name, index) => (  
                <option key={index} value={name}>  
                  {name}  
                </option>  
              ))  
            ) : (  
              <option value="">No unique users available</option>  
            )}  
          </select>  
        </div>   */}
          {/* {selectedCountry && (
            <div className="selected-country">
              <span>{selectedCountry}</span>
              <button className="remove-country" onClick={handleCountryRemove}>×</button>
            </div>
          )}
          <div style={{height:"5px"}}></div> */}


          {/* {(startDate && endDate) && <div className="user-dropdown_KPI" >
            <select
              id="unique-user-dropdown"
              name="unique-user-dropdown"
              value={selectedCountry}
              onChange={handleCountryChange}
            >
              <option value="all">All Country</option>
              {countryArray.length > 0 ? (
                countryArray.map((name, index) => (
                  <option key={index} value={getCountryName(name)}>
                    {getCountryName(name)}
                  </option>
                ))
              ) : (
                <option value="">No Country available</option>
              )}
            </select>
          </div>} */}
          {/* {
            responseData.user == "sajin.mathews@metso.com" ?
              <div>
                <button onClick={getdata}>get pinned data</button>
              </div>
              :
              <div></div>
          } */}
          <div>
            <button onClick={getdata}>Download Pinned User Report</button>
          </div>

          {(startDate && endDate) && <div className="custom-dropdown">
            <div
              className="dropdown-header"
              onClick={handleDropdownToggle}
            >
              {getCountryName(selectedCountry)}
            </div>

            {isOpen && (
              <div className="dropdown-menu">
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                  className="search-input"
                />
                <div className="dropdown-options">
                  {filteredCountries.length > 0 ? (
                    // Add "all" as the first option and then map through the rest
                    ['all', ...filteredCountries.filter((name) => name !== 'all')].map((name, index) => (
                      <div
                        key={index}
                        className="dropdown-option"
                        onClick={() => handleCountrySelect(name == "all" ?
                          "all" : getCountryName(name))}
                      >
                        {name === 'all' ? 'All Countries' : getCountryName(name)}
                      </div>
                    ))
                  ) : (
                    <div className="no-country">No Country available</div>
                  )}
                </div>
              </div>
            )}
          </div>}

        </div>

        <div className="right-container_KPI">
          <div className="table-row">
            <div className="table-section">
              <h2>Bot Adoption</h2>
              <table className="table_KPI">
                <tbody>
                  {/* {!(selectedCountry!="all") && <tr>
                    <td>Current User Base
                      <InfoTooltip description={METRIC_INFO.CURRENT_USER_BASE} />
                    </td>
                    <td>
                      {getCorrected(5455)}
                    </td>
                  </tr>} */}
                  <tr>
                    <td>Pinned user count
                      <InfoTooltip description={METRIC_INFO.PINNED_USER_COUNT} />
                    </td>
                    <td>
                      {getCorrected(KPIData.pinnedUserCount)}
                    </td>
                  </tr>
                  <tr>
                    <td>Unique Users
                      <InfoTooltip description={METRIC_INFO.UNIQUE_USERS} />
                    </td>
                    <td>
                      {getCorrected(KPIData.uniqueUsers)}
                    </td>
                  </tr>
                  <tr>
                    <td>Returning Users
                      <InfoTooltip description={METRIC_INFO.RETURNING_USERS} />
                    </td>
                    <td>
                      {getCorrected(KPIData.usersMoreThanOnce)}
                    </td>
                  </tr>
                  <tr>
                    <td>AskIT Usage Rate
                      <InfoTooltip description={METRIC_INFO.USAGE_RATE} />
                    </td>
                    <td>
                      {getCorrected(KPIData.Adoption_Rate)}%
                    </td>
                  </tr>
                  {/* <tr>  
                  <td>AskIT Accuracy
                  <InfoTooltip description={METRIC_INFO.ASKIT_ACCURACY} />
                  </td>  
                  <td>  
                  {KPIData.askitAccuracy !== undefined ? `${KPIData.askitAccuracy}%` : "N/A"} 
                  </td>  
                </tr> */}
                  <tr>
                    <td>AskIT Adoption Rate
                      <InfoTooltip description={METRIC_INFO.Adoption_Rate} />
                    </td>
                    <td>
                      {getCorrected(KPIData.Adoption_wrt_returning_unique_users)}%
                    </td>
                  </tr>
                  {/* <tr>
                   <td>Returning Users</td>  
                  <td>  
                     {KPIData.usersMoreThanOnce !== undefined  
                      ? KPIData.usersMoreThanOnce  
                      : "N/A"}  
                  </td> 
                </tr> */}
                </tbody>
              </table>
            </div>

            <div className="table-section">
              <h2>Bot Sessions</h2>
              <table className="table_KPI">
                <tbody>
                  <tr>
                    <td>Total Sessions
                      <InfoTooltip description={METRIC_INFO.NUMBER_OF_SESSIONS} last={true} />
                    </td>
                    <td>
                      {getCorrected(KPIData.totalSessions)}
                    </td>
                  </tr>
                  <tr>
                    <td>Agent Transfers
                      <InfoTooltip description={METRIC_INFO.AGENT_TRANSFERS} last={true} />
                    </td>
                    <td>
                      {getCorrected(KPIData.agentTransfers)}
                    </td>
                  </tr>
                  <tr>
                    <td>Chats Handled Rate
                      <InfoTooltip description={METRIC_INFO.CHATS_HANDLED} last={true} />
                    </td>
                    <td>
                      {getCorrected(KPIData.chatsHandled)}%
                    </td>
                  </tr>
                  <tr>
                    <td>Void Sessions
                      <InfoTooltip description={METRIC_INFO.VOID_SESSIONS} last={true} />
                    </td>
                    <td>
                      {getCorrected(KPIData.Void)}
                    </td>
                  </tr>
                  <tr>
                    <td>Bounce Rate
                      <InfoTooltip description={METRIC_INFO.BOUNCE_RATE} last={true} />
                    </td>
                    <td>
                      {getCorrected(KPIData.Bounce_rate)}%
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>




          <div className="table-section">
            <h2>Bot Effectiveness</h2>
            <div className="bot-effectiveness-section">
              <div className="effectiveness-metrics">
                {/* Group 1 */}

                <div className="metric metric-with-tooltip">
                  <div className="metric-title">AskIT Accuracy
                    <InfoTooltip description={METRIC_INFO.ASKIT_ACCURACY} isbutton={false} last={true} />
                  </div>
                  <div className="metric-value">
                    {getCorrected(KPIData.askitAccuracy)}
                  </div>
                </div>
                <div className="metric metric-with-tooltip">
                  <div className="metric-title">Self Service Rate
                    <InfoTooltip description={METRIC_INFO.SELF_SERVICE_RATE} isbutton={false} last={true} />
                  </div>
                  <div className="metric-value">
                    {getCorrected(KPIData.SelfService)}%
                  </div>
                </div>
                <div className="metric metric-with-tooltip">
                  <div className="metric-title">Evaluation Rate
                    <InfoTooltip description={METRIC_INFO.EVALUATION_RATE} isbutton={false} />
                  </div>
                  <div className="metric-value">
                    {getCorrected(KPIData.Evaluation_Rate)}%
                  </div>

                </div>
                <div className="metric metric-with-tooltip">
                  <div className="metric-title">Positive Feedback 👍
                    <InfoTooltip description={METRIC_INFO.POSITIVE_FEEDBACK} isbutton={false} />
                  </div>
                  <div className="metric-value">
                    {getCorrected(KPIData.positiveFeedbacks)}
                  </div>
                </div>
                <div className="metric metric-with-tooltip">
                  <div className="metric-title">Negative Feedback 👎
                    <InfoTooltip description={METRIC_INFO.NEGATIVE_FEEDBACK} isbutton={false} last={true} />
                  </div>
                  <div className="metric-value">
                    {getCorrected(KPIData.negativeFeedbacks)}
                  </div>
                </div>

              </div>
            </div>
          </div>


          <div className="table-section">

            <h2>Bot ITSM Ticket Handling</h2>

            <div className="itsm-dashboard">

              <div className="itsm-group incident-group">

                <div className="itsm-group-title">
                  Incident
                </div>

                <div className="itsm-group-items">

                  <div className="metric metric-with-tooltip">

                    <div className="metric-title">
                      Incident Status Check
                      <InfoTooltip
                        description={METRIC_INFO.INCIDENT_STATUS_CHECK}
                        isbutton={false}
                      />
                    </div>

                    <div className="metric-value">
                      {getCorrected(KPIData.Ticketstatuscount)}
                    </div>

                  </div>

                  <div className="metric metric-with-tooltip">

                    <div className="metric-title">
                      Incidents Updated
                      <InfoTooltip
                        description={METRIC_INFO.INCIDENT_UPDATE}
                        isbutton={false}
                        last={true}
                      />
                    </div>

                    <div className="metric-value">
                      {getCorrected(KPIData.ticketsUpdated)}
                    </div>

                  </div>

                  <div className="metric metric-with-tooltip">

                    <div className="metric-title">
                      User Resolved Incident
                      <InfoTooltip
                        description={METRIC_INFO.USER_RESOLVED_INCIDENTS}
                        isbutton={false}
                      />
                    </div>

                    <div className="metric-value">
                      {getCorrected(KPIData.ticketsResolved)}
                    </div>

                  </div>

                  <div className="metric metric-with-tooltip">

                    <div className="metric-title">
                      Incidents Created
                      <InfoTooltip
                        description={METRIC_INFO.INCIDENTS_CREATED}
                        isbutton={false}
                      />
                    </div>

                    <div className="metric-value">
                      {getCorrected(KPIData.ticketsCreated)}
                    </div>

                  </div>

                  <div className="metric metric-with-tooltip">

                    <div className="metric-title">
                      Reopened Tickets
                      <InfoTooltip
                        description={METRIC_INFO.REOPENED_INCIDENTS}
                        isbutton={false}
                        last={true}
                      />
                    </div>

                    <div className="metric-value">
                      {getCorrected(KPIData.ticketsReopened)}
                    </div>

                  </div>

                </div>

              </div>

              <div className="itsm-group service-request-group">

                <div className="itsm-group-title">
                  Request Status Check
                </div>

                <div className="itsm-group-items">

                  <div className="metric metric-with-tooltip">

                    <div className="metric-title">
                      Service Request Status Check
                      <InfoTooltip
                        description={METRIC_INFO.REQUEST_STATUS_CHECK}
                        isbutton={false}
                      />
                    </div>

                    <div className="metric-value">
                      {getCorrected(KPIData.RequestStatuscount)}
                    </div>

                  </div>

                  <div className="metric metric-with-tooltip">

                    <div className="metric-title">
                      Service Request Updated
                      <InfoTooltip
                        description={METRIC_INFO.SERVICE_REQUEST_UPDATE}
                        isbutton={false}
                        last={true}
                      />
                    </div>

                    <div className="metric-value">
                      {getCorrected(KPIData.ServiceRequestUpdated)}
                    </div>

                  </div>


                  <div className="metric metric-with-tooltip">

                    <div className="metric-title">
                      Change Request Status Check
                      <InfoTooltip
                        description={METRIC_INFO.CH_St}
                        isbutton={false}
                      />
                    </div>

                    <div className="metric-value">
                      {getCorrected(KPIData.Changecount)}
                    </div>

                  </div>

                  <div className="metric metric-with-tooltip">

                    <div className="metric-title">
                      ACR Status Check
                      <InfoTooltip
                        description={METRIC_INFO.ACR_St}
                        isbutton={false}
                      />
                    </div>

                    <div className="metric-value">
                      {getCorrected(KPIData.Acrcount)}
                    </div>

                  </div>

                </div>

              </div>

              <div className="itsm-group approval-flow-group">

                <div className="itsm-group-title">
                  Approval Flow
                </div>

                <div className="itsm-group-items">

                  <div className="metric metric-with-tooltip">

                    <div className="metric-title">
                      Approval Status Check
                      <InfoTooltip
                        description={METRIC_INFO.APPROVAL_St}
                        isbutton={false}
                      />
                    </div>

                    <div className="metric-value">
                      {getCorrected(KPIData.Aprcount)}
                    </div>

                  </div>

                  <div className="metric metric-with-tooltip">

                    <div className="metric-title">
                      Request Approved
                      <InfoTooltip
                        description={METRIC_INFO.approved}
                        isbutton={false}
                      />
                    </div>

                    <div className="metric-value">
                      {getCorrected(KPIData.approved)}
                    </div>

                  </div>

                  <div className="metric metric-with-tooltip">

                    <div className="metric-title">
                      Request Rejected
                      <InfoTooltip
                        description={METRIC_INFO.rejected}
                        isbutton={false}
                      />
                    </div>

                    <div className="metric-value">
                      {getCorrected(KPIData.rejected)}
                    </div>

                  </div>

                </div>

              </div>

              {/* <div className="itsm-individual-cards">

             

              </div> */}

            </div>

          </div>


          <div className="table-section">
            <h2>Knowledge Management Effectiveness</h2>
            <div className="effectiveness-metrics">
              {/* Group 2 */}
              <div className="metric metric-with-tooltip">
                <div className="metric-title">KM Queries Answered
                  <InfoTooltip description={METRIC_INFO.KB_QUERIES_ANSWERED} isbutton={false} />
                </div>
                <div className="metric-value">
                  {getCorrected(KPIData.kmanswer)}
                </div>
              </div>
              <div className="metric metric-with-tooltip" onClick={handleDownloadReport}>
                <div className="metric-title">KM Queries UnAnswered
                  <InfoTooltip description={METRIC_INFO.KB_QUERIES_UNANSWERED} isbutton={false} />
                </div>
                <div className="metric-value">
                  {getCorrected(KPIData.kmunanswer)}
                </div>
              </div>
              <div className="metric metric-with-tooltip">
                <div className="metric-title">KM Efficiency
                  <InfoTooltip description={METRIC_INFO.KB_EFFICIENCY} isbutton={false} last={true} />
                </div>
                <div className="metric-value">
                  {getCorrected(KPIData.accuracy)}
                </div>
              </div>
            </div>
            <div style={{ height: "20px" }}></div>
          </div>

          <div className="table-section">
            <h2>L0 Metrics</h2>

            <div className="l0-hierarchy">


              <div className="l0-top-tree">

                {/* ROOT */}
                <div className="l0-root-wrapper">
                  <div className="metric metric-with-tooltip l0-root-card">
                    <div className="metric-title">
                      Total Interactions
                      <InfoTooltip
                        description={METRIC_INFO.TOTAL_INTERACTIONS}
                        isbutton={false}
                      />
                    </div>

                    <div className="metric-value">
                      {getCorrected(KPIData.Total_interactions)}
                    </div>
                  </div>
                </div>


                {/* ROOT VERTICAL */}
                <div className="l0-root-line"></div>


                {/* RESPONDED / NON-RESPONDED CONNECTOR */}
                <div className="l0-top-split">

                  <div className="l0-top-horizontal"></div>

                  {/* RESPONDED */}
                  <div className="l0-top-column l0-responded-column">

                    <div className="l0-branch-line"></div>

                    <div className="l0-parent-card">

                      <div className="l0-parent-title">
                        Responded Interaction
                      </div>

                      <div className="l0-parent-value">
                        {getCorrected(
                          (Number(KPIData.kmanswer) || 0) +
                          (Number(KPIData.Tools_answered) || 0) +
                          (Number(KPIData.botAbandoned) || 0) +
                          (Number(KPIData.kmAbandoned) || 0)
                        )}
                      </div>


                      {/* ANSWERED + USER ABANDONED */}
                      {/* <div className="l0-responded-line"></div> */}
                      <div className="l0-second-level">

                        {/* ANSWERED */}
                        <div className="l0-second-column">

                          <div className="l0-second-line"></div>

                          <div className="l0-group-card">

                            <div className="l0-group-title">
                              Answered
                            </div>

                            <div className="l0-group-value">
                              {getCorrected(
                                (Number(KPIData.kmanswer) || 0) +
                                (Number(KPIData.Tools_answered) || 0)
                              )}
                            </div>


                            {/* KM + ITSM */}
                            <div className="l0-group-items">

                              {/* KM ANSWERED */}
                              <div className="metric metric-with-tooltip">

                                <div className="metric-title">
                                  KM Answered

                                  <InfoTooltip
                                    description={METRIC_INFO.KB_QUERIES_ANSWERED}
                                    isbutton={false}
                                  />
                                </div>

                                <div className="metric-value">
                                  {getCorrected(KPIData.kmanswer)}
                                </div>

                              </div>


                              {/* ITSM ANSWERED */}
                              <div className="metric metric-with-tooltip">

                                <div className="metric-title">
                                  ITSM Answered

                                  <InfoTooltip
                                    description={METRIC_INFO.ToolsAnswered}
                                    isbutton={false}
                                  />
                                </div>

                                <div className="metric-value">
                                  {getCorrected(KPIData.Tools_answered)}
                                </div>

                              </div>

                            </div>


                            {/* ANSWERED ESCALATION */}
                            <div className="l0-child-line"></div>

                            <div className="l0-escalation-card">

                              <div className="metric metric-with-tooltip">

                                <div className="metric-title">
                                  Answered Escalation

                                  <InfoTooltip
                                    description={METRIC_INFO.answered_escalation}
                                    isbutton={false}
                                  />
                                </div>

                                <div className="metric-value">
                                  {getCorrected(KPIData.answered_escalation)}
                                </div>

                              </div>

                            </div>

                          </div>
                        </div>


                        {/* USER ABANDONED */}
                        <div className="l0-second-column">

                          <div className="l0-second-line"></div>

                          <div className="l0-group-card">

                            <div className="l0-group-title">
                              User Abandoned
                            </div>

                            <div className="l0-group-value">
                              {getCorrected(
                                (Number(KPIData.botAbandoned) || 0) +
                                (Number(KPIData.kmAbandoned) || 0)
                              )}
                            </div>


                            {/* IT BOT + KM */}
                            <div className="l0-group-items">

                              {/* IT BOT ABANDONED */}
                              <div className="metric metric-with-tooltip">

                                <div className="metric-title">
                                  IT Bot Abandoned

                                  <InfoTooltip
                                    description={METRIC_INFO.botAbandoned}
                                    isbutton={false}
                                  />
                                </div>

                                <div className="metric-value">
                                  {getCorrected(KPIData.botAbandoned)}
                                </div>

                              </div>


                              {/* KM ABANDONED */}
                              <div className="metric metric-with-tooltip">

                                <div className="metric-title">
                                  KM Abandoned

                                  <InfoTooltip
                                    description={METRIC_INFO.kmAbandoned}
                                    isbutton={false}
                                  />
                                </div>

                                <div className="metric-value">
                                  {getCorrected(KPIData.kmAbandoned)}
                                </div>

                              </div>

                            </div>

                          </div>
                        </div>

                      </div>

                    </div>

                  </div>


                  {/* 
            NON-RESPONDED
            */}

                  <div className="l0-top-column l0-non-responded-column">

                    <div className="l0-branch-line"></div>

                    <div className="l0-parent-card">

                      <div className="l0-parent-title">
                        Unanswered
                      </div>

                      <div className="l0-parent-value">
                        {getCorrected(KPIData.kmunanswer)}
                      </div>


                      {/* UNANSWERED */}
                      <div className="l0-unanswered-wrapper">

                        <div className="l0-unanswered-line"></div>

                        <div className="l0-group-card">

                          {/* KM UNANSWERED */}
                          <div className="l0-group-items l0-unanswered-items">

                            <div className="metric metric-with-tooltip">

                              <div className="metric-title">
                                Unanswered Abandoned

                                <InfoTooltip
                                  description={METRIC_INFO.nonResponded}
                                  isbutton={false}
                                />
                              </div>

                              <div className="metric-value">
                                {getCorrected(KPIData.unanswer_abandoned)}
                              </div>

                            </div>

                          </div>

                          {/* UNANSWERED ESCALATION */}
                          <div className="l0-child-line"></div>

                          <div className="l0-escalation-card">

                            <div className="metric metric-with-tooltip">

                              <div className="metric-title">
                                Unanswered Escalation

                                <InfoTooltip
                                  description={METRIC_INFO.answered_escalation}
                                  isbutton={false}
                                />
                              </div>

                              <div className="metric-value">
                                {getCorrected(KPIData.unanswer_escalation)}
                              </div>

                            </div>

                          </div>

                        </div>

                      </div>

                    </div>

                  </div>


                </div>

              </div>


              {/* BOTTOM TREE */}

              <div className="l0-bottom-section">

                {/* LEFT - ESCALATIONS */}

                <div className="l0-escalation-area">

                  {/* FALLBACK ESCALATION */}
                  <div className="l0-tree-group">

                    <div className="l0-tree-title">
                      Fallback Escalation
                    </div>
                    <div className="l0-group-value">
                      {getCorrected(
                        (Number(KPIData.fallbackTicketCount) || 0) +
                        (Number(KPIData.fallbackLiveAgentCount) || 0)
                      )}
                    </div>
                    <div className="l0-tree-children">

                      {/* FALLBACK TICKET */}
                      <div className="l0-tree-child">

                        <div className="metric metric-with-tooltip">

                          <div className="metric-title">
                            Fallback Ticket

                            <InfoTooltip
                              description={METRIC_INFO.fallbackTicketCount}
                              isbutton={false}
                            />
                          </div>

                          <div className="metric-value">
                            {getCorrected(KPIData.fallbackTicketCount)}
                          </div>

                        </div>

                      </div>


                      {/* FALLBACK LIVE AGENT */}
                      <div className="l0-tree-child">

                        <div className="metric metric-with-tooltip">

                          <div className="metric-title">
                            Fallback Live Agent

                            <InfoTooltip
                              description={METRIC_INFO.fallbackLiveAgentCount}
                              isbutton={false}
                            />
                          </div>

                          <div className="metric-value">
                            {getCorrected(KPIData.fallbackLiveAgentCount)}
                          </div>

                        </div>

                      </div>

                    </div>

                  </div>


                  {/* FALLBACK → DIRECT */}
                  {/* <div className="l0-escalation-middle-line"></div> */}


                  {/* DIRECT ESCALATION */}
                  <div className="l0-tree-group">

                    <div className="l0-tree-title">
                      Direct Escalation
                    </div>
                    <div className="l0-group-value">
                      {getCorrected(
                        (Number(KPIData.directLiveAgentCount) || 0) +
                        (Number(KPIData.directTicketCount) || 0)
                      )}
                    </div>

                    <div className="l0-tree-children">

                      {/* DIRECT TICKET */}
                      <div className="l0-tree-child">

                        <div className="metric metric-with-tooltip">

                          <div className="metric-title">
                            Direct Ticket

                            <InfoTooltip
                              description={METRIC_INFO.directTicketCount}
                              isbutton={false}
                            />
                          </div>

                          <div className="metric-value">
                            {getCorrected(KPIData.directTicketCount)}
                          </div>

                        </div>

                      </div>


                      {/* DIRECT LIVE AGENT */}
                      <div className="l0-tree-child">

                        <div className="metric metric-with-tooltip">

                          <div className="metric-title">
                            Direct Live Agent

                            <InfoTooltip
                              description={METRIC_INFO.directLiveAgentCount}
                              isbutton={false}
                            />
                          </div>

                          <div className="metric-value">
                            {getCorrected(KPIData.directLiveAgentCount)}
                          </div>

                        </div>

                      </div>

                    </div>

                  </div>

                </div>


                {/* other */}

                <div className="l0-other-metrics">

                  {/* TICKET AVOIDANCE */}
                  <div className="l0-ticket-column">

                    <div className="metric metric-with-tooltip">

                      <div className="metric-title">
                        Ticket Avoidance

                        <InfoTooltip
                          description={METRIC_INFO.ticketAvoidance}
                          isbutton={false}
                        />
                      </div>

                      <div className="metric-value">
                        {getCorrected(KPIData.ticketAvoidance)}
                      </div>

                    </div>




                  </div>




                </div>

              </div>

            </div>

            <div style={{ height: "20px" }}></div>

          </div>


        </div>
      </div>
       <div style={{ height: "150px" }}></div>
    </>
  );
}